<div class="cw-buddy-fullscreen-layout" [ngClass]="theme">
  <div *ngIf="loading" class="cw-buddy-loading-screen">
    <!-- <div class="cw-buddy-loading-skeleton-avatar">
      <span class="cw-buddy-skeleton-dot"></span>
      <span class="cw-buddy-skeleton-dot"></span>
      <span class="cw-buddy-skeleton-dot"></span>
    </div> -->
    <div class="cw-buddy-loading-text">
      <!-- <div class="container"></div> -->
      <div class="greeating-msg">
        <div class="left-text">
          <h1>
            Hello <span class="empName">{{ employeeName }}!</span>
            {{ greetingMessage }}!
          </h1>
          <p class="alina-msg">
            I’m <span class="alina-txt"> {{ LINANAME }}</span
            >&#44; your Digital AI Associate&#44; Happy to Assist you
          </p>
        </div>
      </div>
      <div class="alina-image-getstarted">
        <div class="row w-100">
          <div class="col-md-7 flex-div">
            <button class="btn about-alina-btn" (click)="closeAlina()">
              About <span>{{ LINANAME }}</span>
              <span class="about-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#FFF"
                >
                  <path
                    d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z"
                  /></svg
              ></span>
            </button>
            <span>
              <img src="/assets/images/LINA-Badge.png" alt="alina-img" />
            </span>
          </div>
          <div class="col-md-5">
            <button class="btn getStarted" (click)="getstart()">
              <span>Get Started</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="cw-buddy-chat-wrapper"
    *ngIf="!loading"
    [class.no-headers-main]="isHeadersDisable"
  >
    <div class="chat-board-header">
      <span class="welcome-msg">
        <b>{{ LINANAME }}</b
        >&#44; Your Digital AI Associate</span
      >
      <div class="desktop-view">
        <span
          class="go-back-home"
          [nbTooltip]="isHeadersDisable ? 'MyLTTS Home' : 'Home'"
          [class.disabled]="disableInput"
          (click)="!disableInput && goBackHome()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="35px"
            viewBox="0 -960 960 960"
            width="35px"
            fill="#FFF"
          >
            <path
              d="M200-160v-366L88-440l-48-64 440-336 160 122v-82h120v174l160 122-48 64-112-86v366H520v-240h-80v240H200Zm80-80h80v-240h240v240h80v-347L480-739 280-587v347Zm120-319h160q0-32-24-52.5T480-632q-32 0-56 20.5T400-559Zm-40 319v-240h240v240-240H360v240Z"
            />
          </svg>
        </span>
        <span
          class="cw-buddy-history-title"
          nbTooltip="My Catalog"
          [class.disabled]="disableInput"
          (click)="
            !disableInput && showPromptLibrary('Show Prompt', scrollContainer)
          "
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
            >
              <path
                d="M8.25 6.23438H9.75V7.73438H8.25V6.23438ZM8.25 9.23438H9.75V13.7344H8.25V9.23438ZM9 2.48438C4.86 2.48438 1.5 5.84438 1.5 9.98438C1.5 14.1244 4.86 17.4844 9 17.4844C13.14 17.4844 16.5 14.1244 16.5 9.98438C16.5 5.84438 13.14 2.48438 9 2.48438ZM9 15.9844C5.6925 15.9844 3 13.2919 3 9.98438C3 6.67688 5.6925 3.98438 9 3.98438C12.3075 3.98438 15 6.67688 15 9.98438C15 13.2919 12.3075 15.9844 9 15.9844Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="myAreaText">My Catalog</span></span
        >
        <span
          class="cw-buddy-history-title"
          nbTooltip="History"
          [class.disabled]="disableInput"
          (click)="!disableInput && toggleOverlay('historySection')"
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
            >
              <g opacity="0.8">
                <path
                  d="M2.90464 13.4351C2.94449 13.2811 2.85716 13.067 2.77382 12.9126C2.74799 12.8665 2.71984 12.8219 2.68949 12.779C1.97471 11.6313 1.59374 10.2867 1.59378 8.91186C1.58183 4.96557 4.67238 1.76318 8.49406 1.76318C11.827 1.76318 14.6094 4.20795 15.2592 7.45322C15.3567 7.93436 15.406 8.42504 15.4063 8.91713C15.4063 12.869 12.4349 16.1217 8.61326 16.1217C8.00531 16.1217 7.18552 15.96 6.73828 15.8274C6.29103 15.6949 5.84445 15.5191 5.72923 15.472C5.61128 15.424 5.48603 15.3994 5.35968 15.3992C5.22191 15.3987 5.08546 15.4278 4.95859 15.4847L2.70609 16.3453C2.65687 16.3678 2.60469 16.3823 2.55136 16.3882C2.50918 16.388 2.46744 16.3791 2.42856 16.3617C2.38968 16.3444 2.35442 16.3191 2.32484 16.2872C2.29526 16.2554 2.27194 16.2177 2.25622 16.1762C2.2405 16.1348 2.23271 16.0904 2.23328 16.0458C2.23605 16.0066 2.24272 15.9678 2.2532 15.9301L2.90464 13.4351Z"
                  stroke="white"
                  stroke-width="1.49989"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M5.3125 10.2007C5.8993 10.2007 6.375 9.697 6.375 9.07568C6.375 8.45436 5.8993 7.95068 5.3125 7.95068C4.7257 7.95068 4.25 8.45436 4.25 9.07568C4.25 9.697 4.7257 10.2007 5.3125 10.2007Z"
                  fill="white"
                />
                <path
                  d="M8.50391 10.2007C9.09071 10.2007 9.56641 9.697 9.56641 9.07568C9.56641 8.45436 9.09071 7.95068 8.50391 7.95068C7.9171 7.95068 7.44141 8.45436 7.44141 9.07568C7.44141 9.697 7.9171 10.2007 8.50391 10.2007Z"
                  fill="white"
                />
                <path
                  d="M11.6875 10.2007C12.2743 10.2007 12.75 9.697 12.75 9.07568C12.75 8.45436 12.2743 7.95068 11.6875 7.95068C11.1007 7.95068 10.625 8.45436 10.625 9.07568C10.625 9.697 11.1007 10.2007 11.6875 10.2007Z"
                  fill="white"
                />
              </g>
            </svg>
          </span>
          <span class="historyText">History</span></span
        >
        <span
          class="cw-buddy-history-title"
          [class.disabled]="disableInput"
          (click)="!disableInput && startNewChat(scrollContainer)"
          nbTooltip="New Chat"
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 -960 960 960"
              width="18px"
              fill="#FFF"
            >
              <path
                d="M144-192v-552.28Q144-774 165.16-795t50.88-21h432.24Q678-816 699-794.85T720-744v168-1.5.5q-18 2-36.5 4.5T648-564v-180H216v360h269q-2 10-3.5 19t-1.5 19v17q0 9 2 17H264L144-192Zm144-408h288v-72H288v72Zm0 144h192v-72H288v72Zm396 264v-108H576v-72h108v-108h72v108h108v72H756v108h-72ZM216-384v-360 360Z"
              />
            </svg>
          </span>
          <span class="historyText">New Chat</span>
        </span>
        <span
          class="userguide"
          nbTooltip="User Guide"
          [class.disabled]="disableInput"
          (click)="!disableInput && openUserGuide()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#FFF"
          >
            <path
              d="M479.79-672q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-360h72v-264h-72v264ZM96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z"
            />
          </svg>
        </span>
      </div>

      <div class="mobileMenu-view">
        <span
          class="go-back-home mobileMenu-view"
          nbTooltip="LINA home page"
          [class.disabled]="disableInput"
          (click)="!disableInput && goBackHome()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#FFF"
          >
            <path
              d="M200-160v-366L88-440l-48-64 440-336 160 122v-82h120v174l160 122-48 64-112-86v366H520v-240h-80v240H200Zm80-80h80v-240h240v240h80v-347L480-739 280-587v347Zm120-319h160q0-32-24-52.5T480-632q-32 0-56 20.5T400-559Zm-40 319v-240h240v240-240H360v240Z"
            />
          </svg>
        </span>

        <span
          class="openLinaMenu mobileMenu-view"
          [class.disabled]="disableInput"
          (click)="!disableInput && openLINAMenu()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#FFF"
          >
            <path
              d="M144-264v-72h672v72H144Zm0-180v-72h672v72H144Zm0-180v-72h672v72H144Z"
            />
          </svg>
        </span>
      </div>

      <div
        class="overlay LINAMenu-overlay"
        [ngClass]="showOverlayLINA ? 'show' : 'hidden'"
        (click)="closeLinaPopup()"
      ></div>

      <div class="mobileMenu-view LINAMenu" *ngIf="MobileLINAMenu">
        <span
          class="cw-buddy-history-title"
          nbTooltip="My Catalog"
          [class.disabled]="disableInput"
          (click)="
            !disableInput && showPromptLibrary('Show Prompt', scrollContainer)
          "
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
            >
              <path
                d="M8.25 6.23438H9.75V7.73438H8.25V6.23438ZM8.25 9.23438H9.75V13.7344H8.25V9.23438ZM9 2.48438C4.86 2.48438 1.5 5.84438 1.5 9.98438C1.5 14.1244 4.86 17.4844 9 17.4844C13.14 17.4844 16.5 14.1244 16.5 9.98438C16.5 5.84438 13.14 2.48438 9 2.48438ZM9 15.9844C5.6925 15.9844 3 13.2919 3 9.98438C3 6.67688 5.6925 3.98438 9 3.98438C12.3075 3.98438 15 6.67688 15 9.98438C15 13.2919 12.3075 15.9844 9 15.9844Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="myAreaText">My Catalog</span></span
        >
        <span
          class="cw-buddy-history-title"
          nbTooltip="History"
          [class.disabled]="disableInput"
          (click)="!disableInput && toggleOverlay('historySection')"
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
            >
              <g opacity="0.8">
                <path
                  d="M2.90464 13.4351C2.94449 13.2811 2.85716 13.067 2.77382 12.9126C2.74799 12.8665 2.71984 12.8219 2.68949 12.779C1.97471 11.6313 1.59374 10.2867 1.59378 8.91186C1.58183 4.96557 4.67238 1.76318 8.49406 1.76318C11.827 1.76318 14.6094 4.20795 15.2592 7.45322C15.3567 7.93436 15.406 8.42504 15.4063 8.91713C15.4063 12.869 12.4349 16.1217 8.61326 16.1217C8.00531 16.1217 7.18552 15.96 6.73828 15.8274C6.29103 15.6949 5.84445 15.5191 5.72923 15.472C5.61128 15.424 5.48603 15.3994 5.35968 15.3992C5.22191 15.3987 5.08546 15.4278 4.95859 15.4847L2.70609 16.3453C2.65687 16.3678 2.60469 16.3823 2.55136 16.3882C2.50918 16.388 2.46744 16.3791 2.42856 16.3617C2.38968 16.3444 2.35442 16.3191 2.32484 16.2872C2.29526 16.2554 2.27194 16.2177 2.25622 16.1762C2.2405 16.1348 2.23271 16.0904 2.23328 16.0458C2.23605 16.0066 2.24272 15.9678 2.2532 15.9301L2.90464 13.4351Z"
                  stroke="white"
                  stroke-width="1.49989"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M5.3125 10.2007C5.8993 10.2007 6.375 9.697 6.375 9.07568C6.375 8.45436 5.8993 7.95068 5.3125 7.95068C4.7257 7.95068 4.25 8.45436 4.25 9.07568C4.25 9.697 4.7257 10.2007 5.3125 10.2007Z"
                  fill="white"
                />
                <path
                  d="M8.50391 10.2007C9.09071 10.2007 9.56641 9.697 9.56641 9.07568C9.56641 8.45436 9.09071 7.95068 8.50391 7.95068C7.9171 7.95068 7.44141 8.45436 7.44141 9.07568C7.44141 9.697 7.9171 10.2007 8.50391 10.2007Z"
                  fill="white"
                />
                <path
                  d="M11.6875 10.2007C12.2743 10.2007 12.75 9.697 12.75 9.07568C12.75 8.45436 12.2743 7.95068 11.6875 7.95068C11.1007 7.95068 10.625 8.45436 10.625 9.07568C10.625 9.697 11.1007 10.2007 11.6875 10.2007Z"
                  fill="white"
                />
              </g>
            </svg>
          </span>
          <span class="historyText">History</span></span
        >
        <span
          class="cw-buddy-history-title"
          [class.disabled]="disableInput"
          (click)="!disableInput && startNewChat(scrollContainer)"
          nbTooltip="New Chat"
        >
          <span class="cw-buddy-history-title_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 -960 960 960"
              width="18px"
              fill="#FFF"
            >
              <path
                d="M144-192v-552.28Q144-774 165.16-795t50.88-21h432.24Q678-816 699-794.85T720-744v168-1.5.5q-18 2-36.5 4.5T648-564v-180H216v360h269q-2 10-3.5 19t-1.5 19v17q0 9 2 17H264L144-192Zm144-408h288v-72H288v72Zm0 144h192v-72H288v72Zm396 264v-108H576v-72h108v-108h72v108h108v72H756v108h-72ZM216-384v-360 360Z"
              />
            </svg>
          </span>
          <span class="historyText">New Chat</span>
        </span>
        <span class="cw-buddy-history-title">
          <span
            class="userguide"
            nbTooltip="User Guide"
            [class.disabled]="disableInput"
            (click)="!disableInput && openUserGuide()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              fill="#FFF"
            >
              <path
                d="M479.79-672q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-360h72v-264h-72v264ZM96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z"
              />
            </svg>
          </span>
          <span class="historyText">User Guide</span>
        </span>
      </div>
    </div>

    <nb-sidebar
      state="collapsed"
      tag="menu-historySection"
      right
      fixed
      class="historySection-nav"
      [ngClass]="selectedMenuOption"
      *ngIf="historySection"
    >
      <div class="history-section">
        <div class="header-div">
          <div class="section-header" fxLayout="row">
            <div class="icon-cursor" (click)="closePopup('historySection')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#201D2F"
              >
                <path
                  d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"
                />
              </svg>
            </div>
            <div class="title">Your Search History</div>
          </div>
        </div>
        <div class="history-body">
          <ng-container *ngFor="let item of chartHistorydata">
            <div class="card-div">
              <div
                class="card-text"
                (click)="getTextFromSession(item, scrollContainer)"
              >
                <h2>{{ item?.title }}</h2>
                <p [innerHTML]="item?.question"></p>
                <p class="date-tiem">
                  <span>{{ item?.created_date }}</span>
                  <!-- <span>{{item?.created_date}}</span> -->
                </p>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="history-footer">
          <button class="btn closeHistoryBtn" (click)="closePopup()">
            Cancel
          </button>
        </div>
      </div>
    </nb-sidebar>

    <div
      class="overlay"
      [ngClass]="showOverlay ? 'show' : 'hidden'"
      (click)="closePopup()"
    ></div>

    <main class="cw-buddy-main-panel">
      <div
        class="cw-buddy-messages"
        [class.no-headers]="isHeadersDisable"
        [ngClass]="isFilesSelected ? 'filesSelected' : 'noFilesSelected'"
        #scrollContainer
      >
        <div
          *ngFor="let msg of messages; trackBy: trackByMessage; let i = index"
          class="cw-buddy-msg-row"
          [ngClass]="{
            'cw-buddy-msg-agent': msg.from === 'agent',
            'cw-buddy-msg-user': msg.from === 'user',
          }"
        >
          <img
            [src]="msg.avatar"
            width="30"
            nbTooltip="LINA"
            class="cw-buddy-msg-avatar"
            *ngIf="msg.from === 'agent'"
            alt="Agent"
          />
          <div class="cw-buddy-msg-bubble">
            <div
              class="cw-msg-timestamp"
              [ngClass]="msg.from === 'agent' ? 'left-msg' : 'right-msg'"
              style="color: black; font-size: small"
            >
              {{ formatFullTime(msg.timestamp) }}
            </div>

            <ng-container *ngIf="!msg.thinking; else thinkingSkeleton">
              <div
                [ngClass]="
                  msg.from === 'agent' && msg.streaming
                    ? 'main-message'
                    : 'main-message'
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_264_1956)">
                    <path
                      d="M7.3125 17.9976L5.47101 13.089L0.5625 11.2476L5.47101 9.40607L7.3125 4.49756L9.15398 9.40607L14.0625 11.2476L9.15398 13.089L7.3125 17.9976Z"
                      fill="#6A53E7"
                    />
                    <path
                      d="M3.09375 6.18542L2.26512 3.92031L0 3.09167L2.26512 2.26304L3.09375 -0.0020752L3.92238 2.26304L6.1875 3.09167L3.92238 3.92031L3.09375 6.18542Z"
                      fill="#6A53E7"
                    />
                    <path
                      d="M14.0625 8.99768L12.9688 6.15389L10.125 5.06018L12.9688 3.96647L14.0625 1.12268L15.1562 3.96647L18 5.06018L15.1562 6.15389L14.0625 8.99768Z"
                      fill="#6A53E7"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_264_1956">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div
                  *ngIf="
                    msg.type === 'attendance' && msg.componentData?.length !== 0
                  "
                >
                  <p *ngIf="msg.attendanceType === 'regularization'">
                    Please Select the date(s) and initiate action (Regularize
                    Attendance / Apply Leave)..
                  </p>

                  <p *ngIf="msg.attendanceType === 'leave'">
                    Please select the date(s) and leave type to proceed
                  </p>

                  <ltts-attendance
                    [attendanceData]="msg.componentData?.missedPunches"
                    (selectedDatesChange)="onAttendanceDatesChange($event, msg)"
                    (optionChange)="onAttendanceOptionChange($event, msg)"
                    (promptChange)="onAttendancePromptChange($event)"
                    (fileChange)="onAttendanceFileChange($event)"
                    (validationChange)="
                      onAttendanceValidationChange($event, msg)
                    "
                    (componentDataChange)="
                      onAttendanceComponentDataChange($event, msg)
                    "
                    [type]="msg.attendanceType || 'regularization'"
                    [dropdown]="msg.dropdownData || []"
                    [disabled]="msg.disabled || false"
                  >
                  </ltts-attendance>
                </div>
                <p
                  style="text-align: start; width: 100%"
                  *ngIf="
                    msg.type === 'attendance' && msg.componentData?.length === 0
                  "
                >
                  Your Attendence is Already Regularized
                </p>
                <span
                  (click)="readText(msg.text, 'playBtn' + i, 'pauseBtn' + i)"
                  [id]="'playBtn' + i"
                  class="textSpeak"
                  nbTooltip="read"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                  >
                    <path
                      d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z"
                    />
                  </svg>
                </span>
                <span
                  (click)="pause('playBtn' + i, 'pauseBtn' + i)"
                  [id]="'pauseBtn' + i"
                  class="textPause"
                  nbTooltip="Stop"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                  >
                    <path
                      d="M600-240h120v-480H600v480Zm-360 0h120v-480H240v480Z"
                    />
                  </svg>
                </span>
                <!-- <span (click)="stop('playBtn'+i, 'stopBtn'+i)" [id]="'stopBtn'+i" class="textStop" nbTooltip="Stop">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M320-320h320v-320H320v320ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                </span> -->
                <audio #audioPlayer style="display: none"></audio>
                <span
                  class="copyText"
                  nbTooltip="Copy"
                  [ngClass]="'question' + i"
                  (click)="copyText('question' + i)"
                  *ngIf="i != 1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                  >
                    <path
                      d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
                    />
                  </svg>
                </span>
                <div
                  [innerHTML]="removePreTags(msg.text)"
                  [id]="'question' + i"
                ></div>
              </div>
              <div
                class="sub-message"
                *ngIf="
                  (msg.tagMsg && showOnLoad && SelectLength === i + 1) ||
                  ShowTagmsg
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_264_1956)">
                    <path
                      d="M7.3125 17.9976L5.47101 13.089L0.5625 11.2476L5.47101 9.40607L7.3125 4.49756L9.15398 9.40607L14.0625 11.2476L9.15398 13.089L7.3125 17.9976Z"
                      fill="#6A53E7"
                    />
                    <path
                      d="M3.09375 6.18542L2.26512 3.92031L0 3.09167L2.26512 2.26304L3.09375 -0.0020752L3.92238 2.26304L6.1875 3.09167L3.92238 3.92031L3.09375 6.18542Z"
                      fill="#6A53E7"
                    />
                    <path
                      d="M14.0625 8.99768L12.9688 6.15389L10.125 5.06018L12.9688 3.96647L14.0625 1.12268L15.1562 3.96647L18 5.06018L15.1562 6.15389L14.0625 8.99768Z"
                      fill="#6A53E7"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_264_1956">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ msg.tagMsg }}
              </div>
              <div
                class="cw-buddy-tags"
                [id]="'buddytagsParent' + i + 1"
                *ngIf="
                  showOnLoad && SelectLength === i + 1 && msg.from === 'agent'
                "
              >
                <ng-container *ngFor="let tag of promptLibrary; let i = index">
                  <button
                    [style.background-color]="tag.colorcode"
                    (click)="selectCategory(tag.data, i, scrollContainer)"
                    [class.selected]="selectedTabIndex === i"
                    class="cw-buddy-tag"
                    [nbTooltip]="tag.title"
                    [disabled]="!tag.enable"
                  >
                    {{ tag.categoryName }}
                  </button>
                </ng-container>
              </div>
              <div
                class="cw-buddy-tags"
                [id]="'buddytagsChild' + i + 1"
                *ngIf="
                  subcategories &&
                  SelectLength === i + 1 &&
                  msg.from === 'agent'
                "
              >
                <ng-container
                  *ngFor="let subtag of subcategories; let i = index"
                >
                  <button
                    [style.background-color]="subtag.colorcode"
                    (click)="
                      promptLibraryshow(
                        subtag.data,
                        i,
                        subtag.subCategoryName,
                        scrollContainer
                      )
                    "
                    [class.selected]="selectedIndex === i"
                    class="cw-buddy-tag secondLine"
                    [nbTooltip]="subtag.title"
                    [disabled]="!subtag.enable"
                  >
                    {{ subtag.subCategoryName }}
                  </button>
                </ng-container>
              </div>
            </ng-container>

            <div
              class="promt-library"
              [id]="'buddytagsSubChild' + i + 1"
              *ngIf="
                selectedCategory &&
                textindex &&
                SelectLength === i + 1 &&
                msg.from === 'agent'
              "
            >
              <h3>
                These are frequently used prompts for
                {{ selectedCategoryName }} information. I will learn from any
                new questions you ask and add them to my library of helpful
                suggestions.
                <span class="viewAll" *ngIf="showAll" (click)="showAllitem()">{{
                  viewAllText
                }}</span>
              </h3>
              <div class="promt-cards-parent">
                <ng-container
                  *ngFor="
                    let item of questions | slice: 0 : itemLimit;
                    let i = index
                  "
                >
                  <div
                    class="promt-card"
                    [class.selected]="selectedQuestionIndex === i"
                    *ngIf="(i < 5 || showmore) && item.enable"
                    (click)="
                      item.enable && useThisText(item.name, scrollContainer, i)
                    "
                    [nbTooltip]="item?.title"
                    [ngClass]="!item.enable ? 'disabled' : ''"
                  >
                    <div class="promt-text">
                      {{ item.name }}
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <ng-template #thinkingSkeleton>
              <div class="cw-buddy-skeleton-msg" style="margin-top: 10px">
                <!-- {{compileMsg}} -->
                <!-- <span class="cw-buddy-skeleton-dot"></span>
                <span class="cw-buddy-skeleton-dot"></span>
                <span class="cw-buddy-skeleton-dot"></span> -->
                <!-- <br> -->
                <svg
                  width="200"
                  height="40"
                  viewBox="0 0 200 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none" stroke="none">
                    <circle cx="20" cy="20" r="6" fill="#0078D4">
                      <animate
                        attributeName="r"
                        values="6;10;6"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <ellipse cx="50" cy="20" rx="8" ry="4" fill="#00B294">
                      <animate
                        attributeName="rx"
                        values="8;12;8"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </ellipse>
                    <circle cx="80" cy="20" r="6" fill="#FFD700">
                      <animate
                        attributeName="r"
                        values="6;10;6"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <ellipse cx="110" cy="20" rx="8" ry="4" fill="#0078D4">
                      <animate
                        attributeName="rx"
                        values="8;12;8"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </ellipse>
                    <circle cx="140" cy="20" r="6" fill="#00B294">
                      <animate
                        attributeName="r"
                        values="6;10;6"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </circle>
                    <ellipse cx="170" cy="20" rx="8" ry="4" fill="#FFD700">
                      <animate
                        attributeName="rx"
                        values="8;12;8"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </ellipse>
                    <polygon
                      points="190,20 195,25 190,30 185,25"
                      fill="#00CC6A"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        values="1;1.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                      <animate
                        attributeName="fill-opacity"
                        values="1;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      />
                    </polygon>
                  </g>
                </svg>
              </div>
            </ng-template>
          </div>
          <img
            [src]="msg.avatar"
            class="cw-buddy-msg-avatar"
            *ngIf="msg.from === 'user'"
            alt="User"
          />
        </div>
      </div>
      <div class="cw-buddy-inputbar">
        <!-- <span class="alina-input-img"><img -->
        <span
          class="alina-input-img"
          [ngClass]="isFilesSelected ? 'filesSelected' : 'noFilesSelected'"
          ><img
            src="/assets/images/LINA-Prompt-img-withbg.png"
            alt="img"
            nbTooltip="LINA Prompt"
        /></span>
        <div class="input-container">
          <textarea
            class="cw-buddy-input"
            id="inputMessage"
            #LINAInput
            placeholder="Type your message..."
            [(ngModel)]="inputMessage"
            (keyup.enter)="sendMessage(scrollContainer)"
            aria-label="Type your message"
            [disabled]="disableInput"
            [ngClass]="isFilesSelected ? 'filesSelected' : 'noFilesSelected'"
          ></textarea>
          <!-- [disabled]="disableInput"></textarea> -->
          <ul
            class="files-fullList"
            *ngIf="showremaining && selectedFiles.length > 4"
            #measurableDiv
            [ngStyle]="{
              'top.px':
                -((selectedFiles.length - 3) * 33) < -300
                  ? -300
                  : -((selectedFiles.length - 3) * 33),
            }"
          >
            <li>Uploaded Files({{ selectedFiles.length }})</li>
            <li *ngFor="let file of selectedFiles | slice: 4">
              <span [nbTooltip]="file.name">{{ file.name }}</span>
              <button
                class="remove-list"
                *ngIf="
                  !uploadStatusMap[file.name] ||
                  uploadStatusMap[file.name] === 'pending'
                "
                (click)="!disableInput && removeFile(file.name)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#000"
                >
                  <path
                    d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                  />
                </svg>
              </button>

              <span
                class="remove-list progressBard"
                *ngIf="uploadStatusMap[file.name] === 'uploading'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#000"
                >
                  <path
                    d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z"
                  />
                </svg>
              </span>

              <!-- Show success icon -->
              <span
                class="upload-status-icon success"
                *ngIf="uploadStatusMap[file.name] === 'success'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#28a745"
                >
                  <path
                    d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
                  />
                </svg>
              </span>

              <!-- Show error icon -->
              <span
                class="upload-status-icon error"
                *ngIf="uploadStatusMap[file.name] === 'error'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#dc3545"
                >
                  <path
                    d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"
                  />
                </svg>
              </span>
            </li>
          </ul>
          <ul class="uploaded-list" *ngIf="selectedFiles.length">
            <ng-container *ngFor="let file of selectedFiles; let i = index">
              <li *ngIf="i < 4" class="file-tag">
                <div class="filenameDiv">
                  <span class="fileName" [nbTooltip]="file.name">{{
                    file.name
                  }}</span>

                  <!-- Show remove button if upload hasn't started -->
                  <button
                    class="remove-list"
                    *ngIf="
                      !uploadStatusMap[file.name] ||
                      uploadStatusMap[file.name] === 'pending'
                    "
                    (click)="!disableInput && removeFile(file.name)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="#000"
                    >
                      <path
                        d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                      />
                    </svg>
                  </button>

                  <span
                    class="remove-list progressBard"
                    *ngIf="uploadStatusMap[file.name] === 'uploading'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#000"
                    >
                      <path
                        d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z"
                      />
                    </svg>
                  </span>

                  <!-- Show success icon -->
                  <span
                    class="upload-status-icon success"
                    *ngIf="uploadStatusMap[file.name] === 'success'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#28a745"
                    >
                      <path
                        d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
                      />
                    </svg>
                  </span>

                  <!-- Show error icon -->
                  <span
                    class="upload-status-icon error"
                    *ngIf="uploadStatusMap[file.name] === 'error'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#dc3545"
                    >
                      <path
                        d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"
                      />
                    </svg>
                  </span>
                </div>

                <!-- <progress class="progresss" [ngClass]="getSafeClassName(file.name)" [id]="'mybar'+(i+1)" [value]="uploadProgressMap[file.name]" max="100" style="width:100%; height:4px;"></progress> -->
                <div
                  class="progress-bar-container"
                  *ngIf="uploadStatusMap[file.name] === 'uploading'"
                  style="width: 100%"
                >
                  <progress
                    [value]="uploadProgressMap[file.name] || 0"
                    max="100"
                    style="width: 100%; height: 6px"
                  ></progress>
                </div>
              </li>
            </ng-container>
            <button
              *ngIf="selectedFiles.length > 4"
              (click)="showremainingFiles()"
              class="btn viewMoreFiles"
            >
              View all ({{ selectedFiles.length - 4 }})
            </button>
          </ul>

          <button
            *ngIf="fileUploadFlag"
            #recordButton
            class="upload-button"
            [disabled]="disableInput"
            aria-label="File Upload"
          >
            <input
              #fileInput
              style="opacity: 0; position: absolute; z-index: 999; width: 36px"
              type="file"
              (change)="onFilesSelected($event)"
              multiple
              id="file-input"
              accept=".xlsx,.xls,.pptx,.ppt,image/*, application/pdf"
            />

            <label class="file-uploading" for="file">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#6A53E7"
              >
                <path
                  d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                />
              </svg>
            </label>
          </button>

          <button
            #recordButton
            class="mic-button"
            [disabled]="disableInput"
            (mousedown)="startRecording()"
            aria-label="Voice input"
            nbTooltip="{{
              isTranscribing
                ? 'Processing audio...'
                : isRecording
                  ? 'Recording...'
                  : 'Click to record'
            }}"
          >
            <!-- Loading spinner for transcribing -->
            <div *ngIf="isTranscribing" class="mic-loading">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#FFF"
              >
                <path
                  d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                />
              </svg>
            </div>
            <!-- Loading spinner for transcribing -->
            <div *ngIf="isTranscribing" class="mic-loading">
              <svg width="20" height="20" viewBox="0 0 50 50">
                <circle
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke="#6A53E7"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-dasharray="31.416"
                  stroke-dashoffset="31.416"
                >
                  <animate
                    attributeName="stroke-array"
                    dur="2s"
                    values="0 31.416;15.708 15.708;0 31.416"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="stroke-dashoffset"
                    dur="2s"
                    values="0;-15.708;-31.416"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
            </div>

            <!-- Microphone icon -->
            <svg
              *ngIf="!isTranscribing"
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              [attr.fill]="isRecording ? '#FF4444' : '#6A53E7'"
              [class.mic-pulse]="isRecording"
            >
              <path
                d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-40Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"
              />
            </svg>
          </button>
        </div>
        <button
          class="cw-buddy-send"
          [disabled]="disableInput"
          (click)="sendMessage(scrollContainer)"
          aria-label="Send message"
        >
          <!-- <nb-icon icon="paper-plane-outline"></nb-icon> -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#FFF"
          >
            <path
              d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z"
            />
          </svg>
        </button>
      </div>
    </main>
  </div>
  <div class="about-alina-div" *ngIf="openAlinaPopup">
    <div class="aboutAlina-Text">
      <div class="alina-header">
        <span class="close-span" (click)="closeAlina()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="#FFF"
          >
            <path
              d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
            />
          </svg>
        </span>
        <img src="/assets/images/About_LINA.png" alt="about-LINA-img" />
      </div>
    </div>
  </div>
  <div class="user-guide" *ngIf="showUserGuide">
    <div class="aboutUser-Guide">
      <div class="userGuide-header">
        <span class="close-span" (click)="closeUserGuide()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="#FFF"
          >
            <path
              d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
            />
          </svg>
        </span>
        <img src="/assets/images/user_guide_new.png" alt="user-guide-img" />
      </div>
    </div>
  </div>
</div>
